import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {defaultErrorHandler} from '../../../context/context';
import queryParameterUtils from '../../../utils/query-parameter-utils';
import uploadV1Client from '../../../infrastructure/acerill/upload-v1-client';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';
import Section from '../../../libs/react-components-admin/section/section';
import SuccessBox from '../../../libs/react-components-admin/box/success-box';
import {useLocation, useParams} from 'react-router-dom';
import {TextField} from '../../../libs/react-components-admin/fields/text-like-field';
import EmailAddresses from '../../../libs/react-components-admin/email/email-addresses';
import SaveCancelBar from '../../../libs/react-components-admin/buttons/save-cancel-bar';

const Support = ({value, onChange}) => {

  const [model, setModel] = useState(value || {});

  useEffect(() => { onChange(model); }, [model]);

  return <div>
    <label>Support email addresses</label>
    <div className="form-text mb-2">An alert will be sent to these email addresses if a problem occurs</div>
    <div className="row justify-content-center">
      <div className="col-12 col-md-8">
        <EmailAddresses minEmailAddresses={1}
                        initialModel={model.emailAddresses}
                        onChange={v => setModel({...model, emailAddresses: v})}/>
      </div>
    </div>
  </div>;
};

const Account = ({value, onChange}) => {

  const [model, setModel] = useState(value);

  useEffect(() => { onChange(model); }, [model]);

  return <>
    <TextField id="account-name"
               label="Name"
               helpBlock={<>Helps you identify this account</>}
               value={model.name}
               onChange={v => setModel({...model, name: v})}/>
    <Support value={model.support}
             onChange={v => setModel({...model, support: v})}/>
  </>;
};

const GoogleDriveAccount = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const {accountId} = useParams();

  const [account, setAccount] = useState('reload');
  const [successMessageCode, setSuccessMessageCode] = useState();

  useEffect(() => {
    if (account === 'reload') {
      loadAccount();
    }
  }, [account]);

  useEffect(
    () => { setSuccessMessageCode(queryParameterUtils.tryFindQueryParameter('success_message_code')); },
    [location.search]
  );

  const loadAccount = () => {
    uploadV1Client.findGoogleDriveAccountById(accountId)
      .then(acc => setAccount(acc))
      .catch(err => defaultErrorHandler(err));
  };

  const removeSuccessMessage = () => {
    const urlSearchParams = new URLSearchParams(location.search);
    urlSearchParams.delete('success_message_code');
    navigate(`${location.pathname}?${urlSearchParams.toString()}`);
  };

  const save = () => uploadV1Client.updateGoogleDriveAccount(account)
    .then(() => removeSuccessMessage());

  const cancel = () => {
    removeSuccessMessage();
    setAccount('reload');
    return Promise.resolve();
  };

  const successMessage = () => {
    return 'Google Drive integration successfully setup. From now on, all files will be uploaded to Google Drive.';
  };

  return <Section title="Integration - Google Drive" noMargin={true}>
    <div className="row justify-content-center mb-4">
      <div className="col-12 col-md-8">
        {successMessageCode &&
        <SuccessBox align="center">{successMessage(successMessageCode)}</SuccessBox>
        }
        {account === 'reload' ?
          <CenteredSpinner/> :
          <>
            <div className="mb-4">
              <Account value={account}
                       onChange={v => setAccount(v)}/>
            </div>
            <SaveCancelBar saveAction={() => save()}
                           cancelAction={() => cancel()}
                           errorHandler={defaultErrorHandler}/>
          </>
        }
      </div>
    </div>
  </Section>;
};

export default GoogleDriveAccount;
